import { FC, useMemo, } from "react";
// 组件
import CopyText from '../CopyText';
// 方法
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import { getChildrenPublicPath, urlParamsTOUrl } from "../utils/utils";
// 常量
import { TABLE_COLUMN_EMPTY } from '../constants/constant';
import { RouteLinkProps } from "./interface";

/** 路由跳转 */
const RouteLink: FC<RouteLinkProps> = props => {
  const { text, pathname, state, query, isLocalArea, isCopy, children, } = props;
  const { dispatch, } = useLayoutContext();
  /** 点击链接文字 */
  const handleClick = () => {
    if (!pathname) return;
    if (isLocalArea) {
      const newPathname = `${getChildrenPublicPath()}${pathname}`;
      window.$wujie?.bus.$emit('children-route-change', urlParamsTOUrl(newPathname, query), { state: state, });
      return;
    }
    window.$wujie?.bus.$emit('children-route-change', urlParamsTOUrl(pathname, query), { state: state, });
  };
  /** 判断是否有页面权限 */
  const isReute = useMemo(() => {
    if (!pathname) return false;
    return dispatch('isRoute', isLocalArea ? `${getChildrenPublicPath()}${pathname}` : pathname);
  }, [pathname, isLocalArea]);
  const linkNode = text || children;
  if (!text && text !== 0 && !children) return <span>{TABLE_COLUMN_EMPTY}</span>;
  if (!isReute) {
    return (isCopy && typeof linkNode === 'string') ? (
      <CopyText text={linkNode} />
    ) : <span>{linkNode}</span>;
  }
  return (
    <div
      onClick={handleClick}
      className="link-text"
    >
      {
        (isCopy && typeof linkNode === 'string') ? (
          <CopyText text={linkNode} />
        ) : linkNode
      }
    </div>
  );
};

RouteLink.defaultProps = {
  isLocalArea: true,
};

export default RouteLink;
